import io from "socket.io-client";

let socket = undefined;

const options = {
  timeout: 4000,
  transports: ["websocket"],
};

if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
  socket = io(`ws://localhost:8000`, options);
  console.log(`Connecting to ws://localhost:8000`);
} else {
  socket = io(`wss://${window.location.host}`, options);
  console.log(`Connecting to wss://${window.location.host}`);
}

const initState = socket;

const socketReducer = (state = initState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default socketReducer;
